import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { ui } = constants.colors;
const { textXSObj } = typographyStyles;
const { mediaQuery: breakpoint } = mediaQueryStyles;

const fixedEmailChangerHeight = "100px";

export const radioButtonCss = {
  root: {
    backgroundColor: ui.neutral[25],
    margin: "10px 0",
    padding: 10,
    borderRadius: 4,
  },
};

export const newEmailContainerCss = {
  marginTop: 30,
  display: "flex",
  flexDirection: "row",
  gap: 25,
  alignItems: "center",
  [breakpoint.upTo("xs")]: {
    flexDirection: "column",
  },
};

export const newEmailInputCss = {
  root: {
    [breakpoint.downTo("xs")]: {
      marginBottom: 5,
    },
  },
  underInput: {
    position: "absolute",
  },
};

export const newEmailInputContainerCss = {
  width: "300px",
  height: fixedEmailChangerHeight,
};

export const newEmailInputSpinnerCss = {
  root: {
    width: "20px",
    height: "20px",
    margin: 0,
  },
};

export const newEmailInputValidIconCss = {
  root: {
    width: "20px",
    height: "20px",
  },
};

export const newEmailSeparatorContainerCss = {
  height: fixedEmailChangerHeight,
  padding: "38px 0",
};

export const newEmailSeparatorCss = {
  ...textXSObj,
  color: ui.neutral[700],
};

export const googleButtonContainerCss = {
  height: fixedEmailChangerHeight,
  padding: "27px 0",
};

export const googleButtonCss = {
  width: "100%",
  justifyContent: "center",
};

export const googleIconCss = {
  ">g": {
    stroke: "none !important",
  },
};
